import type { JSX } from "preact";
import { classNames } from "@gss/common/classNames";
import { Badge } from "./Badge";
import { Help } from "./icons";
import type { LabelProps } from "./Label";

interface Props extends LabelProps {
    length?: number;
}

export function FormLabel({
    title,
    bold,
    className,
    length,
    children,
    ...rest
}: Props): JSX.Element {
    return (
        <label
            {...rest}
            title={title}
            className={classNames("form-label", bold && "fw-bold", className)}
        >
            {children}
            {length != null && <Badge className="ms-1">{length}</Badge>}
            {title != null && <Help className="ms-1" />}
        </label>
    );
}
